import { Button } from "@devhop/ui";
import { ArrowLeftIcon } from "lucide-react";

type ShopRoleFormToolbarProps = {
  isEdit: boolean;
  onBack: () => void;
};

export function ShopRoleFormToolbar({
  isEdit,
  onBack,
}: ShopRoleFormToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">
          {isEdit ? "ແກ້ໄຂບົດບາດ" : "ເພີ່ມບົດບາດ"}
        </h2>
        <p className="text-muted-foreground text-sm">
          {isEdit
            ? "ປ່ຽນຊື່ຫຼືສິດການເຂົ້າເຖິງຂອງບົດບາດນີ້."
            : "ສ້າງບົດບາດໃໝ່ແລະກຳນົດສິດການເຂົ້າເຖິງ."}
        </p>
      </div>
      <Button variant="outline" onClick={onBack} className="shrink-0">
        <ArrowLeftIcon className="size-4" />
        ກັບຄືນ
      </Button>
    </div>
  );
}
